import React, { useRef, useState, useEffect, useCallback } from 'react';
import { Button, Tooltip, } from 'antd';

import { Application } from "@yulintu/freesia-bootstrap";

import useDesigner from "../hooks/useDesigner";
import useDesignerMessage from "../hooks/useDesignerMessage";

export default function Addon(props) {

    const designer = useDesigner();

    const toJson = useCallback(() => {

        let json = designer.toJson();
        let datastr = "data:text/json;charset=utf-8," + encodeURIComponent(json);
        let downloadAnchorNode = document.createElement('a')
        downloadAnchorNode.setAttribute("href", datastr);
        downloadAnchorNode.setAttribute("download", `diagrams.json`)
        downloadAnchorNode.click();
        downloadAnchorNode.remove();

    }, [designer]);

    return <>
        <div className='layout-h center' onClick={toJson}>
            <Application.SystemSvgIcon type="json2" style={{ fontSize: 20, marginRight: 7, }} />
            导出为 Json
        </div>
    </>
}